<template>
  <div>
    <div class="thisTitle">
      <span class="thisIcon">
        <img src="../../common/images/icon-jifenlogo.png" alt=""/>
      </span>
      <span>积分</span>
    </div>

    <div class="JiFenWrap">
      <el-table :data="scoreArr" class="filterTable" size="small" border style="width: 100%"
                header-row-class-name="table-header">
        <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
        <el-table-column prop="masterName" label="指标" align="center"></el-table-column>
        <el-table-column label="分值设定" align="center">
          <template slot-scope="scope">
            <div v-if="!isEdit">{{scope.row.score}}</div>
            <div class="form myForm" v-if="isEdit">
              <el-form :model="scope.row" :rules="rules" ref="scoreArr" label-width="100px" class="demo-ruleForm">
                <el-form-item prop="score">
                  <el-input v-model.number="scope.row.score" auto-complete="on" :maxlength="4"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
  //韩金辰7月重写
  import {mapMutations} from "vuex";
  import formRules from '../../common/js/formRules'

  export default {
    name: "",
    data() {
      return {
        scoreArr: [],
        rules: {
          score: [formRules.number, {required: true, message: '分值不能为空', trigger: 'blur'}]
        },
      };
    },
    props: ["isEdit"],
    mounted() {
      console.log('主页传入积分页的数据', this.$store.state.jiFenArr)
      this.scoreArr = this.$store.state.jiFenArr
    },
    methods: {
      ...mapMutations(["changejiFenArr"]),
      //勿删，会被父组件调用
      checkVals() {
        let text = ''
        //编辑时，积分页的数据被修改后，$store中的jsFenArr会被赋值为新的，初值是''，赋值后是[]类型
        this.scoreArr.map(item => {
          if (!item.score && item.score !== 0) {
            text = "警告 积分页分值设定没填写！";
          } else if (isNaN(item.score)) {
            text = "警告 积分页分值请填写数字类型！";
          }
        })
        if (text) {
          this.$message({
            message: text,
            type: "warning"
          });
          return false
        } else {
          this.changejiFenArr(this.scoreArr);
          return true
        }
      }
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .JiFenWrap {
    background-color: white;
    padding: 20px;
    margin: 10px 0;
  }

  .thisIcon {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 50%;
    margin-right: 10px;
  }

  .thisTitle span:last-child {
    font-size: 15px;
    vertical-align: middle;
    font-weight: bold;
    margin-bottom: 10px;
  }

  input::-webkit-input-placeholder {
    color: #666666;
    opacity: 1;
  }

  .position {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/jiFen.vue